import React, { useState, useRef } from 'react';

export function ProductCarousel({ images, alt }) {
  const [active, setActive] = useState(0);
  const touchStartX = useRef(null);

  const goNext = () => setActive((prev) => (prev + 1) % images.length);
  const goPrev = () => setActive((prev) => (prev - 1 + images.length) % images.length);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const deltaX = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(deltaX) > 40) {
      if (deltaX < 0) goNext();
      else goPrev();
    }
    touchStartX.current = null;
  };

  return (
    <div
      className="product-carousel"
      onClick={goNext}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {images.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={alt}
          className={`product-img${i === active ? ' active' : ''}`}
          loading="lazy"
        />
      ))}
      <div className="product-carousel-dots">
        {images.map((src, i) => (
          <button
            key={src}
            className={`product-carousel-dot${i === active ? ' active' : ''}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setActive(i); }}
            aria-label={`Show image ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
